import React, {useEffect} from 'react'
import RolesPermissions from '../components/RolesPermissions'
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { connect, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getAdminRolesList,  getRolesLoading , getRolePermissionsList, getPermissions} from "../selector/selectors";
import { loadRolesList,loadPermissionsList, loadRolePermissionsList, updateRolePermissions } from "../api/permissionsapi";
import LoaderComponent from '../components/LoaderComponent';
import { Link } from 'react-router-dom';

const ManageRoleBaseAccess = ({
    isLoading,
    adminRolesList,
    permissionList,
    rolePermissionsList,
    startLoadingRoles,
    startLoadingPermissions,
    startLoadingRolePermissions
  }) => {
    
    const dispatch = useDispatch();
    const [value, setValue] = React.useState('1');
    const [filterValue, setFilterValue] = React.useState(adminRolesList[0]?.id);
    const[updatedPermissionList, setUpdatedPermissionList] = React.useState([]);
    const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleRoleChange = (event) => {
        setFilterValue(event.target.value);
    };

    useEffect(() => {
        startLoadingRoles();
    }, [startLoadingRoles]);
    
    useEffect(() => {
        startLoadingRolePermissions(filterValue);
    },[filterValue, startLoadingRolePermissions])
  
    useEffect(() => {
        startLoadingPermissions();
    },[startLoadingPermissions])
      

    useEffect(() => {
        const data = permissionList.map(permission => {
            let checkedVal = false;
            rolePermissionsList?.filter(rolePermission => rolePermission.permission_id === permission.id ?  checkedVal = true  : checkedVal);
            if(checkedVal){
              return {...permission,checked:true}
            } else {
              return {...permission,checked:false}
            } 
        });
        setUpdatedPermissionList(data);
    },[permissionList,rolePermissionsList]);
  
    const handleSwitchChange = (id) => (event) =>{
        const updatedData = updatedPermissionList.map(permission => {
            if(permission.id === id){
              return {...permission,checked:event.target.checked}
            }
            return permission;
        });
        setUpdatedPermissionList(updatedData);
    };
  
    const handleSaveData = () => {
        let roleId = filterValue;
        let permissions = updatedPermissionList;
        dispatch(updateRolePermissions(roleId,permissions));
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/roles">Roles</Link>
                                <Link className="tabingLinks" to="/web/users">Users</Link>
                                {/* <Link className="tabingLinks" to="/web/app/users">Manage SiteTech app users</Link> */}
                                <Tab label="Access Control" value="1" />
                                {list?.userDetails?.role_id === 1 &&
                                    <Link className="tabingLinks" to="/web/controller-permissions">Controller Access Control</Link>
                                }
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <RolesPermissions filterValue={filterValue} adminRolesList={adminRolesList} handleRoleChange={handleRoleChange} handleSaveData={handleSaveData} updatedPermissionList={updatedPermissionList} handleSwitchChange={handleSwitchChange} /> 
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    )
}


const mapStateToProps = (state) => ({
    isLoading: getRolesLoading(state),  
    adminRolesList:getAdminRolesList(state), 
    permissionList:getPermissions(state), 
    rolePermissionsList:getRolePermissionsList(state), 
});

const mapDispatchToProps = (dispatch) => ({
    startLoadingRoles: ()                   => dispatch(loadRolesList( )),
    startLoadingPermissions: ()             => dispatch(loadPermissionsList()),
    startLoadingRolePermissions: (roleId)   => dispatch(loadRolePermissionsList(roleId)),
});
  
export default connect(mapStateToProps, mapDispatchToProps)(ManageRoleBaseAccess);